import { takeEvery, all, call, put } from 'redux-saga/effects';
import * as types from './productActionTypes';
import * as actions from './productActions';
import * as endpoints from '../../services/endpoints';
import * as alert from '../alert/alertActions';
import { errorHandler } from '../../helpers/errorHandler';

function* getProductSaga(action) {
  try {
    const { data } = yield call(endpoints.getProduct, action.payload);
    yield put(actions.getProductSuccess(data));
  } catch (e) {
    yield put(actions.getProductError(e));
    yield call(errorHandler, e);
  }
}

function* addProductSaga(action) {
  try {
    const { data } = yield call(endpoints.addProduct, action.payload);
    yield put(actions.addProductSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Ürün başarıyla oluşturuldu',
        variant: 'success',
      }));
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/products');
        }, 1500);
      }
    }
  } catch (e) {
    yield put(actions.addProductError(e));
    yield call(errorHandler, e);
  }
}

function* updateProductSaga(action) {
  try {
    const { data } = yield call(endpoints.updateProduct, action.payload);
    yield put(actions.updateProductSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Ürün başarıyla güncellendi',
        variant: 'success',
      }));
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/products');
        }, 1000);
      }
    }
  } catch (e) {
    yield put(actions.updateProductError(e));
    yield call(errorHandler, e);
  }
}

function* deleteProductSaga(action) {
  try {
    const { data } = yield call(endpoints.deleteProduct, action.payload);
    yield put(actions.deleteProductSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Ürün başarıyla silindi',
        variant: 'success',
      }));
      yield put(actions.getProductRequest({}));
    }
  } catch (e) {
    yield put(actions.deleteProductError(e));
    yield call(errorHandler, e);
  }
}

function* getProductDetailSaga(action) {
  try {
    const { data } = yield call(endpoints.getProductDetail, action.payload);
    yield put(actions.getProductDetailSuccess(data));
  } catch (e) {
    yield put(actions.getProductDetailError(e));
    yield call(errorHandler, e);
  }
}

function* watchGetProduct() {
  yield takeEvery(types.GET_PRODUCT_REQUEST, getProductSaga);
}
function* watchAddProduct() {
  yield takeEvery(types.ADD_PRODUCT_REQUEST, addProductSaga);
}
function* watchUpdateProduct() {
  yield takeEvery(types.UPDATE_PRODUCT_REQUEST, updateProductSaga);
}
function* watchDeleteProduct() {
  yield takeEvery(types.DELETE_PRODUCT_REQUEST, deleteProductSaga);
}
function* watchGetProductDetail() {
  yield takeEvery(types.GET_PRODUCT_DETAIL_REQUEST, getProductDetailSaga);
}

export function* productSaga() {
  yield all([
    watchGetProduct(),
    watchAddProduct(),
    watchUpdateProduct(),
    watchDeleteProduct(),
    watchGetProductDetail(),
  ]);
} 